import { View, StyleSheet, TouchableOpacity } from 'react-native';
import PropTypes from 'prop-types';
import React, { memo, useState, useEffect } from 'react';
import QText from './QText';
import { useTheme } from 'react-native-paper';
import LinkButton from './LinkButton';
import { useTranslation } from 'react-i18next';
import { getIsMobileDevice } from '../utils';

const SignBottomBar = ({
  bottomBarTxt,
  linkTxt,
  onLinkPress,
  footerlinkShow,
  navigation,
  showCopyRightText,
  showCompanyDetails,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [companyName, setCompanyName] = useState('');
  const isMobile = getIsMobileDevice();

  useEffect(() => {
    if (showCompanyDetails) {
      setTimeout(() => {
        setCompanyName('Blueed Technology Pvt Ltd');
      }, 100);
    }
  }, [showCompanyDetails]);

  return (
    <View
      style={[
        { backgroundColor: theme.colors.onBackground },
        styles.signBottomBarContainer,
      ]}
    >
      {footerlinkShow && (
        <View
          style={{
            flexDirection: isMobile ? 'column' : 'row',
            width: '100%',
            paddingHorizontal: 10,
            paddingVertical: 20,
            maxWidth: 600,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <View
            style={{
              width: isMobile ? '100%' : '25%',
              marginBottom: isMobile ? 15 : 0,
            }}
          >
            <TouchableOpacity
              onPress={() => navigation.navigate('TermsAndConditionsScreen')}
            >
              <QText
                style={{
                  color: theme.colors.primary,
                  fontSize: 13,
                  textAlign: 'center',
                }}
              >
                {t('terms_and_conditions')}
              </QText>
            </TouchableOpacity>
          </View>
          <View style={{ width: isMobile ? '100%' : '25%' }}>
            <TouchableOpacity
              onPress={() => navigation.navigate('PrivacyPolicyScreen')}
            >
              <QText
                style={{
                  color: theme.colors.primary,
                  fontSize: 13,
                  textAlign: 'center',
                }}
              >
                {t('privacy_policy')}
              </QText>
            </TouchableOpacity>
          </View>
          <View style={{ width: '25%' }}>
            <TouchableOpacity
              onPress={() => navigation.navigate('RefundPolicyScreen')}
            >
              <QText
                style={{
                  color: theme.colors.primary,
                  fontSize: 13,
                  textAlign: 'center',
                }}
              >
                {t('refund_policy')}
              </QText>
            </TouchableOpacity>
          </View>
        </View>
      )}
      <View style={[styles.row, isMobile && styles.mobileRow]}>
        {showCopyRightText && showCompanyDetails && (
          <QText
            style={[
              styles.bottomTxt,
              {
                color: theme.colors.secondaryText,
                paddingHorizontal: 10,
                textAlign: 'center',
                paddingBottom: isMobile ? 10 : 20,
                paddingTop: isMobile ? 10 : 0,
                width: isMobile ? '100%' : 'auto',
              },
            ]}
          >
            {new Date().getFullYear()} © waitkyu{' '}
            {companyName ? `| ${companyName} |` : ''} All rights reserved
          </QText>
        )}
        {bottomBarTxt && (
          <QText
            style={[
              styles.bottomTxt,
              {
                color: theme.colors.secondaryText,
                width: isMobile ? '100%' : 'auto',
                textAlign: isMobile ? 'center' : 'left',
                marginTop: isMobile ? 5 : 0,
              },
            ]}
          >
            {bottomBarTxt}
          </QText>
        )}
        {linkTxt && (
          <View
            style={{
              width: isMobile ? '100%' : 'auto',
              marginTop: isMobile ? 10 : 0,
            }}
          >
            <LinkButton
              title={linkTxt}
              onPress={onLinkPress}
              titleStyle={styles.linkTxt}
              style={{
                marginVertical: 0,
                alignSelf: isMobile ? 'center' : 'auto',
              }}
            />
          </View>
        )}
      </View>
    </View>
  );
};

SignBottomBar.propTypes = {
  bottomBarTxt: PropTypes.string,
  linkTxt: PropTypes.string,
  onLinkPress: PropTypes.func,
  footerlinkShow: PropTypes.bool,
  showCopyRightText: PropTypes.bool,
  showCompanyDetails: PropTypes.bool,
};

SignBottomBar.defaultProps = {
  bottomBarTxt: '',
  linkTxt: '',
  onLinkPress: () => {},
  footerlinkShow: false,
  navigation: '',
  showCopyRightText: false,
  showCompanyDetails: false,
};

const styles = StyleSheet.create({
  signBottomBarContainer: {
    //flex: 1,
    borderTopWidth: 1,
    borderTopColor: '#1E243D',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 5,
  },
  bottomTxt: {
    fontSize: 13,
  },
  linkTxt: {
    fontSize: 13,
    fontWeight: 'bold',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    gap: 10,
  },
  mobileRow: {
    flexDirection: 'column',
    paddingHorizontal: 15,
    paddingVertical: 10,
  },
});

export default memo(SignBottomBar);
